import { createReducer } from 'typesafe-actions';

import { Contract, Deal, SongSummary } from '~/features/dashboard/store/models';
import {
    createNewDealStageActions,
    createNewSongStageActions,
    getContactsActions,
    getContractsActions,
    getDealDetailsActions,
    getDealsActions,
    getMusicsActions,
    newDealFormNextStep,
    newDealFormPrevStep,
    newSongFormNextStep,
    newSongFormPrevStep,
    resetNewDealForm,
    editNewDealForm,
    editNewSongForm,
    resetNewSongForm,
    toggleNawDrawerAction,
    getDealTypesList,
    getDealFormatsList,
    getDealCodesList,
    getContactTypesList,
    createContactActions,
    getDealSongsSummaryActions,
    createSongTags,
    getSearchDealFilterActions,
    getSearchSongFilterActions,
    getSearchMoneyFilterActions,
    getSearchTeamFilterActions,
    isSongFormEditing,
    isDealFormEditing,
    countryListForm,
    resetNewContactForm,
    detectSongChange,
    setlinkAllSong,
    getDealSubDealsSummaryActions,
    getDealDocumentsActions,
    getDealDocumentTypesActions,
    getDealRegionsList,
    getUserProfileTypes,
    getSongListingsList,
    updateDefaultActions,
    newSongFormGoToStep,
    getAKAsListingsList,
    getSoundListingsList,
    getArtworkListingsList, resetAKAsListingsList,
} from './actions';
import { User } from '~/store/user/models';
import { AKAsList } from '~/models/contacts.dto';
import { fakeMoney } from '~/mock/fakeMoney';
import { SongSummaryListDto, MusicListItemDto } from '~/models/music/music.dto';
import { MoneyListItemDto } from '~/models/contract.dto';
import {
    NewDealResponseDto,
    DealTypeListResponse,
    DealFormatListResponse,
    DealCodeListResponse,
    DealRegionListResponse,
} from '~/models/deals/new-deal/NewDealResponse.dto';
import { contactCodeListResponse } from '~/models/team/TeamCodeList.dto';
import { DealResponse } from '~/models/deals';
import { NewSongResponseDto, songTagsFields } from '~/models/music/new-song/newSongResponse.dto';
import { DealSummaryListDto } from '~/models/deals/DealsListItem.dto';
import { DealSubTypeList } from '~/models/deals/DealSubTypeList.dto';
import { DealDocumentDto, DealDocumentTypeDto } from '~/models/deals/DealDocument.dto';
import { UserProfile } from '~/models/profile/UserProfile.dto';
import { SongListings } from '~/models/music/SongListings.dto';

export const NEW_DEAL_FORM_STEPS_COUNT = 7;
export const NEW_SONG_FORM_STEPS_COUNT = 6;
export const NEW_MONIES_FORM_STEPS_COUNT = 6;

export class State {
    activeCreator: User | null = null;
    nawDrawerShowed: boolean = true;
    deals: Deal[] = [];
    dealsResponse: DealResponse[] = [];
    contractsList: MoneyListItemDto[] = [];
    musicList: MusicListItemDto[] = [];
    songSummaryDealList: SongSummaryListDto[] = [];
    dealSummaryList: DealSummaryListDto[] = [];
    contracts: Contract[] = fakeMoney;
    newDeal: NewDealResponseDto | null = null;
    newDealFormStep: number = 1;
    newSong: NewSongResponseDto | null = null;
    songTags: songTagsFields | null = null;
    searchDealFilter: any | '';
    searchSongFilter: any | '';
    searchMoneyFilter: any | '';
    searchTeamFilter: any | '';
    newSongFormStep: number = 1;
    dealTypeList: DealTypeListResponse[] = [];
    dealSubTypeList: DealSubTypeList = {};
    dealFormatList: DealFormatListResponse[] = [];
    dealCodeList: DealCodeListResponse[] = [];
    dealRegionList: DealRegionListResponse[] = [];
    contactCodeList: contactCodeListResponse[] = [];
    currentContact: User | null = null;
    songSummary: SongSummary[] = [];
    isSongEditing: boolean = true;
    isDealEditing: boolean = false;
    countryCodeList: any | null = null;
    detectSongChange: boolean = false;
    linkAllSong: boolean = false;
    dealSubDeals: DealSummaryListDto[] = [];
    dealDocuments: DealDocumentDto[] = [];
    dealDocumentTypes: DealDocumentTypeDto[] = [];
    userProfileData: UserProfile | null = null;
    songListingsList: SongListings[] = [];
    soundListingsList: SongListings[] = [];
    artworkListingsList: SongListings[] = [];
    AKAsList: AKAsList[] = [];
}
export const reducer = createReducer(new State())
    .handleAction(createNewDealStageActions.success, (state, { payload }) => ({
        ...state,
        newDeal: { ...payload },
    }))
    .handleAction(isSongFormEditing, (state, { payload }) => ({
        ...state,
        isSongEditing: payload,
    }))
    .handleAction(isDealFormEditing, (state, { payload }) => ({
        ...state,
        isDealEditing: payload,
    }))
    .handleAction(editNewDealForm, (state, { payload }) => ({
        ...state,
        newDealFormStep: payload.step + 1,
        // newDeal: null,
    }))
    .handleAction(resetNewDealForm, state => ({
        ...state,
        newDealFormStep: 1,
        newDeal: null,
    }))
    .handleAction(newDealFormPrevStep, state => ({
        ...state,
        newDealFormStep: state.newDealFormStep - 1,
    }))
    .handleAction(newDealFormNextStep, state => ({
        ...state,
        newDealFormStep: state.newDealFormStep + 1,
    }))
    .handleAction(createNewSongStageActions.success, (state, { payload }) => ({
        ...state,
        newSong: { ...payload },
    }))
    .handleAction(getSearchDealFilterActions.success, (state, { payload }) => ({
        ...state,
        searchDealFilter: payload.searchDealFilter || '',
    }))
    .handleAction(getSearchSongFilterActions.success, (state, { payload }) =>
        // console.log(payload),
        ({
            ...state,
            searchSongFilter: payload.searchSongFilter,
        })
    )
    .handleAction(getSearchMoneyFilterActions.success, (state, { payload }) => ({
        ...state,
        searchMoneyFilter: payload.searchMoneyFilter,
    }))
    .handleAction(getSearchTeamFilterActions.success, (state, { payload }) => ({
        ...state,
        searchTeamFilter: payload.searchTeamFilter,
    }))
    .handleAction(createSongTags.success, (state, { payload }) => ({
        ...state,
        SongTags: state.songTags,
        ...payload,
    }))
    .handleAction(editNewSongForm, (state, { payload }) => ({
        ...state,
        newSongFormStep: payload.step + 1,
        // newSong: null,
    }))
    .handleAction(countryListForm, (state, { payload }) => ({
        ...state,
        countryCodeList: payload.countryCodeList,
    }))
    // .handleAction(editNewSongToStepForm, (state, { payload }) => ({
    //     ...state,
    //     newSongFormStep: payload.step,
    //     newSong: { ...payload.newSongState }
    // }))
    .handleAction(resetNewSongForm, state => ({
        ...state,
        newSongFormStep: 1,
        newSong: null,
    }))
    .handleAction(newSongFormPrevStep, state => ({
        ...state,
        newSongFormStep: state.newSongFormStep - 1,
    }))
    .handleAction(newSongFormNextStep, state => ({
        ...state,
        newSongFormStep: state.newSongFormStep + 1,
    }))
    .handleAction(newSongFormGoToStep, (state, { payload }) => ({
        ...state,
        newSongFormStep: payload.step,
    }))
    .handleAction(getContactsActions.success, (state, { payload }) => ({
        ...state,
        activeCreator: { ...payload },
    }))
    .handleAction(getDealsActions.success, (state, { payload }) => ({
        ...state,
        deals: [...payload.deals],
        dealsResponse: [...payload.dealsResponse],
    }))
    .handleAction(getDealDetailsActions.success, (state, { payload }) => {
        return {
            ...state,
            deals: [...payload.deals],
            dealsResponse: [...payload.dealsResponse],
            dealSubTypeList: payload.dealSubTypeList,
        };
    })
    .handleAction(getUserProfileTypes.success, (state, { payload }) => ({
        ...state,
        userProfileData: { ...payload },
    }))
    .handleAction(updateDefaultActions.success, (state, { payload }) => ({
        ...state,
        userProfileData: { ...payload },
    }))
    .handleAction(getMusicsActions.success, (state, { payload }) => ({
        ...state,
        musicList: [...payload],
    }))
    // .handleAction(getMusicsActions.update, (state, { payload }) => ({
    //     ...state,
    //     musicList: [...payload],
    // }))
    .handleAction(getDealSongsSummaryActions.success, (state, { payload }) => ({
        ...state,
        songSummary: [...payload.songs],
    }))
    .handleAction(getContractsActions.success, (state, { payload }) => ({
        ...state,
        contractsList: [...payload],
    }))
    .handleAction(toggleNawDrawerAction, (state, { payload }) => ({
        ...state,
        nawDrawerShowed: typeof payload !== 'undefined' ? payload : !state.nawDrawerShowed,
    }))
    .handleAction(getDealTypesList.success, (state, { payload }) => ({
        ...state,
        dealTypeList: [...payload],
    }))

    .handleAction(getDealFormatsList.success, (state, { payload }) => ({
        ...state,
        dealFormatList: [...payload],
    }))
    .handleAction(getDealCodesList.success, (state, { payload }) => ({
        ...state,
        dealCodeList: [...payload],
    }))
    .handleAction(getDealRegionsList.success, (state, { payload }) => ({
        ...state,
        dealRegionList: [...payload],
    }))
    .handleAction(getSongListingsList.success, (state, { payload }) => ({
        ...state,
        songListingsList: [...payload],
    }))
    .handleAction(getSoundListingsList.success, (state, { payload }) => ({
        ...state,
        soundListingsList: [...payload],
    }))
    .handleAction(getArtworkListingsList.success, (state, { payload }) => ({
        ...state,
        artworkListingsList: [...payload],
    }))
    .handleAction(getContactTypesList.success, (state, { payload }) => ({
        ...state,
        contactCodeList: [...payload],
    }))
    .handleAction(createContactActions.success, (state, { payload }) => ({
        ...state,
        currentContact: { ...payload },
    }))
    .handleAction(resetNewContactForm, state => ({
        ...state,
        currentContact: null,
    }))
    .handleAction(detectSongChange, (state, { payload }) => ({
        ...state,
        detectSongChange: payload.value,
    }))
    .handleAction(setlinkAllSong, (state, { payload }) => ({
        ...state,
        linkAllSong: payload.value,
    }))
    .handleAction(getDealSubDealsSummaryActions.success, (state, { payload }) => ({
        ...state,
        ...payload,
    }))
    .handleAction(getDealDocumentsActions.success, (state, { payload }) => ({
        ...state,
        ...payload,
    }))
    .handleAction(getDealDocumentTypesActions.success, (state, { payload }) => ({
        ...state,
        ...payload,
    }))
    .handleAction(resetAKAsListingsList, state => ({
        ...state,
        AKAsList: [],
    }))
    .handleAction(getAKAsListingsList.success, (state, { payload }) => ({
        ...state,
        AKAsList: payload,
    }));
